import GiftingBlockBase from '../GiftingBlockBase';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { defineMessages } from 'react-intl';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';



const GENERIC_GIFTING_BLOCK_STRINGS = defineMessages({
  GIVE_THE_GIFT: {
    defaultMessage: 'Give the gift of adventure'
  },
  GIFT_PRO: {
    defaultMessage: 'Gift Pro'
  },
  WHETHER_YOURE_CELEBRATING: {
    defaultMessage:
      'Whether you’re celebrating someone you love or getting to know someone new, AllTrails Pro makes the perfect gift for the adventurer in your life.'
  }
});

type Props = {
  languageRegionCode: LanguageRegionCode;
};

const GenericGiftingBlock = ({ languageRegionCode }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: {
      GIVE_THE_GIFT,
      GIFT_PRO,
      WHETHER_YOURE_CELEBRATING
    }
  } = useFormatMessage(GENERIC_GIFTING_BLOCK_STRINGS);
  return (
    <GiftingBlockBase
      imgSrc={`https://cdn-assets.alltrails.com/assets/images/gifting/giftcards-${languageRegionCode}.png`}
      title={GIVE_THE_GIFT}
      subtext={WHETHER_YOURE_CELEBRATING}
      ctaText={GIFT_PRO}
      ctaLink={LanguageSupportUtil.wrapUrlSafe('/gift?ref=homepage_gift_genericgiftingblock', languageRegionCode)}
    />
  );
};

export default GenericGiftingBlock;
